// テンプレート操作
import {
    SETING_CONTRACT_GET_ALL
} from '../constants/ActionTypes'
import { glasConfig } from '../constants/Config'
import request from 'axios'
import { showLoading, hideLoading } from 'react-redux-loading-bar'

const resultSuccess = (type, data) => {
    return {
        type: type,
        data,
    }
}

// テンプレート取得
export const getAllContractAction = () => {
    return (dispatch) => {
        dispatch(showLoading())
        return request
            .get(glasConfig.url_base + glasConfig.path_setting_cotract , {
                headers: {
                    Authorization: localStorage.getItem('token'),
                },
            })
            .then((response) => {
                dispatch(hideLoading())
                const parser = new DOMParser();
                const doc = parser.parseFromString(response.data, 'text/html');
                const bodyHTML = doc.body.innerHTML;
                let body = bodyHTML.replace('<div><h2 style="box-sizing: border-box; margin-top: 0px; margin-bottom: 0.5rem; line-height: 1.2; color: rgb(33, 37, 41); font-size: 18px; font-family: &quot;Helvetica Neue&quot;, Helvetica, Arial, sans-serif; padding-bottom: 15px; background-color: rgb(255, 255, 255);">Stella 利用規約</h2><div><br></div>', '');
                dispatch(resultSuccess(SETING_CONTRACT_GET_ALL, body))
               
            })
            .catch((error) => {
                dispatch(hideLoading())
                console.log('error on call ' + SETING_CONTRACT_GET_ALL, error)
                throw error
            })
    }
}

